/* eslint-disable */
export default {
  callerCall: '발신자',
  transferCall: '전달',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
